var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.46 15.856a1.15 1.15 0 0 1 0 2.289l-.117.005h-.009a1.15 1.15 0 0 1 0-2.3h.009zM12.334 6a3.5 3.5 0 0 1 1.978 6.389c-.314.214-.58.43-.76.647-.175.212-.218.36-.218.464a1 1 0 1 1-2 0c0-.725.322-1.31.68-1.742.267-.32.58-.592.878-.814l.289-.206A1.5 1.5 0 1 0 10.834 9.5a1 1 0 1 1-2 0 3.5 3.5 0 0 1 3.5-3.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.334 1c6.075 0 11 4.925 11 11s-4.925 11-11 11-11-4.925-11-11 4.925-11 11-11m0 2a9 9 0 1 0 0 18 9 9 0 0 0 0-18",
    clipRule: "evenodd"
  })));
};
export default Svg24;